export const {
    PORT,
    REACT_APP_NAME_APP,
} = process.env;